import React from 'react';
import Slider from './slider';
import Achievements from './Achievements';
// import Events from './events';
import Startups from './startups';
import Programs from './programs';
import Carousel from './CarouselWithContent';
// import "../styles/Navbar.css";
// import Slider1 from "./slider1"
// import para1 from "../images/New folder/1.jpg"
import para1 from '../global-images/bg-1.jpg';
import Updates from './Updates';
function Landing() {



  return (
    <>
      <div className='bg-white' id="home">
        <Carousel />
        {/* <Slider /> */}
        <Updates />
        <Achievements />
        {/* <h1 className='text-center text-montserrat text-3xl text-bold font-montserrat font-bold  text-purple-800'>Programs</h1> */}
        <Programs />
        {/* <div className=" flex items-center justify-center bg-fixed bg-center bg-cover " style={{ backgroundImage: `url(${para1})`, height: '50vh',padding:'10px' }}>
        </div> */}
        {/* <Startups /> */}
        {/* <Events /> */}

      </div>
    </>
  );
}

export default Landing;
